import { Field } from "formik";
import { useEffect, useRef } from "react";
import { EMPTY_STRING } from "../../../constants";
import {
  QUERY_PARAMETER_COUNT,
  FIELDS,
  QUERY_PARAMETER_TYPES,
} from "../datamodels.constants";
import { FieldsGrid } from "../../../components/molecules";
import { isEqual } from "lodash";
import CustomModelDefinition from "./CustomModelDefinition";

const { SELECT, TEXT, CUSTOM_REQUEST, CUSTOM } = FIELDS;
const SINGLE = "single";
const MULTI = "multi";
const REQUEST_BODY = "Request Body";

const RequestBody = ({ name, values, collections, options, handleChange }) => {
  const preSelectedValues = useRef(values);

  useEffect(() => {
    if (values && !isEqual(preSelectedValues.current, values)) {
      preSelectedValues.current = values;
      handleChange(values, name);
    }
  }, [values, name, handleChange]);

  const getConditionalFields = (type) => {
    switch (type) {
      case SINGLE:
        return (
          <div className="flex flex-row mt-2">
            <Field
              as={SELECT}
              className="form-control mr-1"
              name={`${name}.modelName`}
              value={values.modelName}
            >
              <option key={name} value={EMPTY_STRING}>
                Select an option
              </option>
              {collections.map(({ id, refName, name }) => (
                <option key={id} value={refName}>
                  {name}
                </option>
              ))}
            </Field>
            <Field
              as={SELECT}
              className="form-control"
              name={`${name}.count`}
              value={values.count}
            >
              <option key={name} value={EMPTY_STRING}>
                Select an option
              </option>
              {QUERY_PARAMETER_COUNT.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </Field>
          </div>
        );
      case MULTI:
        return (
          <FieldsGrid
            name={`${name}.models`}
            values={values.models}
            label={name}
            fields={[
              { name: "name", type: TEXT },
              { name: "modelName", options: collections, type: SELECT },
              { name: "count", options: QUERY_PARAMETER_COUNT, type: SELECT },
            ]}
            styleClasses={{ selectFields: "flex grid grid-cols-2 gap-2 my-1" }}
          />
        );
      case CUSTOM:
        return (
          <FieldsGrid
            label="field"
            name={`${name}.customModels.fields`}
            values={values.customModels.fields}
            fields={[
              { name: "name", type: TEXT },
              { name: "type", options: QUERY_PARAMETER_TYPES, type: SELECT },
            ]}
            styleClasses={{
              orderFirst: "order-1 mb-1",
              orderSecond: "order-2",
            }}
          />
        );
      case CUSTOM_REQUEST:
        return (
          <div className="flex mt-2 justify-center">
            <CustomModelDefinition
              name={`${name}.customRequest`}
              title={REQUEST_BODY}
              value={values.customRequest}
              handleChange={handleChange}
            />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Field
        as={SELECT}
        className="form-control capitalize"
        name={`${name}.type`}
        value={values.type}
      >
        <option key={name} value={EMPTY_STRING}>
          Select an option
        </option>
        {options ? (
          options.map((option) => (
            <option key={option} value={option} className="capitalize">
              {option}
            </option>
          ))
        ) : (
          <option key={name} value={EMPTY_STRING}>
            Content not found
          </option>
        )}
      </Field>
      {values && getConditionalFields(values.type)}
    </>
  );
};

export default RequestBody;
